export default {
  emailCollectorPopupTitle: {
    id: 'lead_collection_popup_title',
    defaultMessage: 'Oh, you’ll know.',
  },
  emailCollectorPopupDescription: {
    id: 'lead_collection_popup_description',
    defaultMessage:
      'Sign up for emails to be the first to know about flash sales, exclusive offers, and more on Back Market.',
  },
  emailCollectorPopupFormPlaceholder: {
    id: 'lead_collection_popup_form_text',
    defaultMessage: 'Email',
  },
  emailCollectorPopupFormButton: {
    id: 'lead_collection_popup_button',
    defaultMessage: 'Sign up',
  },
  emailCollectorPopupFormMandatoryError: {
    id: 'email_collector_mandatory_field_error',
    defaultMessage: 'This field is mandatory',
  },
  emailCollectorPopupLegalText: {
    id: 'lead_collection_popup_legal_text',
    defaultMessage:
      'By subscribing, you agree to receive our promotional communications via email. You can unsubscribe at any time using the link in any of our marketing emails, or request to access, rectify, or delete your data.',
  },
  emailCollectorPopupLinkPolicy: {
    id: 'lead_collection_popup_link_privacy_policy',
    defaultMessage: 'For more details, please refer to our privacy policy',
  },
  emailCollectorPopupTermsTitle: {
    id: 'lead_collection_popup_terms_title',
    defaultMessage: '',
  },
  emailCollectorPopupTermsDescription: {
    id: 'lead_collection_popup_terms_description',
    defaultMessage: '',
  },
  toastSuccessTitle: {
    id: 'lead_collection_popup_toast_title',
    defaultMessage: 'Shazam!',
  },
  toastSuccessMessage: {
    id: 'lead_collection_popup_toast_description',
    defaultMessage: 'Freddy said if I believe I can fly, then I can fly!',
  },
}
